import { FormEventHandler, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { withStyles } from 'vopay';
import { BodyText } from 'UI';
import { TRANSFER_FORM_ID } from './useTransferForm';
import styles from './TransferForm.module.scss';

const cn = withStyles(styles);

type TransferFormProps = {
  isReviewing: boolean;
  onSubmit: FormEventHandler<HTMLFormElement>;
  /** The fields, laid out by the host; its actions are `TransferFormActions`, also placed by the host. */
  children: ReactNode;
};

export default function TransferForm({ isReviewing, onSubmit, children }: TransferFormProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'PartnerAccountTransfer' });

  return (
    <form id={TRANSFER_FORM_ID} className={cn('form')} onSubmit={onSubmit} data-testid="transferForm">
      {isReviewing && (
        <BodyText className={cn('reviewHint')}>
          {t('reviewHint', { defaultValue: 'Review the details below, then submit the transfer.' })}
        </BodyText>
      )}

      {children}
    </form>
  );
}
